import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useLocation,useNavigate } from 'react-router-dom';

import { SESSION_COOKIE, SessionCookie } from '@/types/cookie';
import { isSessionValid } from '@/utils/session';

export function ProtectedRoute( { children }: { children: React.ReactNode } ) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect( () => {
    const sessionCookieStr = Cookies.get( SESSION_COOKIE );
    let sessionCookie: SessionCookie = {};

    if ( sessionCookieStr ) {
      try {
        sessionCookie = JSON.parse( sessionCookieStr ) as SessionCookie;
      } catch( e ) {
        console.error( 'Failed to parse session cookie', e );
      }
    }

    // Redirect to /login if not authenticated or session expired
    if ( !isSessionValid( sessionCookie ) ) {
      Cookies.remove( SESSION_COOKIE, { domain: window.location.hostname, path: '/' } );

      const fromOrigin = location.pathname === '/';
      const redirectParam = !fromOrigin
        ? `?redirect=${ encodeURIComponent( location.pathname + location.search ) }`
        : '';

      navigate( `/login${ redirectParam }`, { replace: true } );
    }
  }, [ navigate, location ] );

  return <>{children}</>;
}

export function PublicRoute( { children }: { children: React.ReactNode } ) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect( () => {
    const sessionCookieStr = Cookies.get( SESSION_COOKIE );
    let sessionCookie: SessionCookie = {};

    if ( sessionCookieStr ) {
      try {
        sessionCookie = JSON.parse( sessionCookieStr ) as SessionCookie;
      } catch( e ) {
        console.error( 'Failed to parse session cookie', e );
      }
    }

    // Redirect to home if authenticated (except for /login routes)
    if (
      sessionCookie?.userId &&
      !location.pathname.startsWith( '/login' )
    ) {
      navigate( '/', { replace: true } );
    }
  }, [ navigate, location ] );

  return <>{children}</>;
}
